/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import ApiClient from "./apiClient";
import _filter from "lodash/filter";
import { MediaObject } from "@/src/types/Entities/MediaObject/MediaObject";

const MAX_UPLOAD_SIZE_IN_MEGABYTES_BY_MIME_TYPE: Record<string, number> = {
  "application/pdf": 25,
  "image/jpeg": 15,
  "image/png": 15,
  "video/x-msvideo": 500,
  "video/mp4": 500,
  "video/mpeg": 500,
  "video/webm": 500,
  "audio/mpeg": 500,
  "audio/ogg": 500,
};

export const checkFileFormat = (filename: string, allowAudioAndVideo = false) => {
  const documentCheck = /\.(jpg|jpeg|png|pdf)$/i.test(filename);

  if (!allowAudioAndVideo) {
    return documentCheck;
  }

  return documentCheck || /\.(avi|mpg|mpeg|webm|ogg|opus|mp3|mp4)$/i.test(filename);
};

export const getMaxUploadSizeInMegabytes = (file: Pick<File, "name" | "type">) => {
  const mimeTypeLimit = MAX_UPLOAD_SIZE_IN_MEGABYTES_BY_MIME_TYPE[file.type];
  if (mimeTypeLimit) {
    return mimeTypeLimit;
  }

  if (/\.pdf$/i.test(file.name)) {
    return 25;
  }
  if (/\.(jpg|jpeg|png)$/i.test(file.name)) {
    return 15;
  }
  if (/\.(avi|mpg|mpeg|webm|ogg|opus|mp3|mp4)$/i.test(file.name)) {
    return 500;
  }

  return 50;
};

export const isAllowMultiplePagesFileType = (fileName: string) => {
  return /(\.jpg)|(\.png)|(\.jpeg)/i.test(fileName);
};

export const formatFilePath = (filePath: string, maxLength = 27) => {
  const outputString = filePath.replace("C:\\fakepath\\", "");
  if (outputString.length <= maxLength) {
    return outputString;
  }

  return outputString.slice(0, Math.round((maxLength - 5) / 2)) + " ... " + outputString.slice(-Math.round((maxLength - 5) / 2));
};

export const urltoFile = (url: string, filename: string, mimeType: string) => {
  return fetch(url)
    .then(function (res) {
      return res.arrayBuffer();
    })
    .then(function (buf) {
      return new File([buf], filename, { type: mimeType });
    });
};

export const postMediaObject = (file: File, fieldname: string) => {
  let formData = new FormData();
  formData.append("file", file);
  formData.append("fieldname", fieldname);
  let headers = new Headers();
  headers.set("Content-Type", "multipart/form-data");
  return ApiClient.post("/anonymous_media_objects", {
    headers: headers,
    body: formData,
  });
};

export const filterMediaObjectsByFieldname = (mediaObjectCollection: MediaObject[], fieldName: string) => {
  return _filter(mediaObjectCollection, ["fieldname", fieldName]) || [];
};
